import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const submitInquiry = (payload) =>
  axios.post(`${API}/inquiries`, payload, { timeout: 20000 });

export const submitPartnerInquiry = (payload) =>
  axios.post(`${API}/partner-inquiries`, payload, { timeout: 20000 });
